import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { FullProjectIssue, IssueComment, ProjectIssueByStatus } from '../types';

export const issueLoaders = getLoaders({
  getIssueCounts: {
    load: async (): Promise<Record<string, number>> => {
      return executeApiCall({
        path: `/projects/issues/status-counts`,

        method: 'get',
      });
    },
  },

  listProjectIssues: {
    load: async ({ projectId }: { projectId: string }): Promise<FullProjectIssue[]> => {
      return executeApiCall({
        path: `/projects/issues/${projectId}`,

        method: 'get',
      });
    },
  },

  issuesByStatus: {
    load: async (payload: {
      status: string;
      startDate?: string;
      endDate?: string;
      paginationToken?: string;
    }): Promise<ProjectIssueByStatus[]> => {
      return executeApiCall({
        path: `/projects/issues/by-status`,

        method: 'get',

        payload,
      });
    },
  },

  findIssue: {
    load: async ({
      projectId,
      issueId,
    }: {
      projectId: string;
      issueId: string;
    }): Promise<FullProjectIssue> => {
      return executeApiCall({
        path: `/projects/issues/issue`,

        method: 'get',

        payload: {
          project: projectId,
          issue: issueId,
        },
      });
    },
  },

  issueCommentHistory: {
    load: async ({ id }: { id: string }): Promise<IssueComment[]> => {
      return executeApiCall({
        path: `/projects/issues/comments/history/${id}`,

        method: 'get',
      });
    },
  },
});
